import axios from 'axios'

export class TenantSettingsService {
  async updateTenantSettings (data: { displayName: string; email: string }) {
    return await axios.put(`${process.env.VUE_APP_BACKEND_URL}/tenant/settings`, data)
  }
}

export default new TenantSettingsService()
